import {Component, Vue} from 'vue-property-decorator';
import {BusinessType, SelectedOptions, ServiceAddress} from '@/products-and-services/ProductsAndServicesModels';
import CartLocation from '@/products-and-services/CartLocation.vue';

@Component({
    components: {
        CartLocation
    }
})
export default class ShoppingCartMixin extends Vue {

    miniCart = {
        title: 'Shopping Cart',
        heading: 'For the most accurate prices and offerings, please add your location.',
        bodyIcon: '/uploads/icons/ionicons_svg_md-globe-faded.svg'
    };

    get selectedOptions(): SelectedOptions {
        return this.$store.getters.getShoppingCartSelection();
    }

    get location(): ServiceAddress {
        return this.$store.getters.getLocation as ServiceAddress;
    }

    get hasCartItem(): boolean {
        return Boolean(this.selectedOptions && this.selectedOptions.services && this.selectedOptions.services.length);
    }

    get discounts() {
        return this.selectedOptions.discounts || [];
    }
    get oneTimeFees() {
        return this.selectedOptions.oneTimeFees || [];
    }

    get isLoading(): boolean {
        return this.$store.state.loadingCart;
    }

    get isEmployee(): boolean {
        return this.$store.state.isEmployee || false;
    }

    public isSubmitted(): boolean {
        return this.$store.state.shoppingCartData.submitted || false;
    }

    get isTavern(): boolean {
        return this.$store.getters.isTavernTvInCart;
    }

    public returnToEmployeePortal() {
        // Caller's of this method should only call if we're in "Employee" mode but we check again just to be safe.
        if (this.isEmployee) {
            window.location.href = process.env.VUE_APP_ADMIN_APP_URL + '/shopping-carts/carts/' + this.$store.getters.getCartNumber();
        }
    }

    occupancyCartDisplay(value: string): string {
        if (!value) {
            return '';
        }
        const [val] = JSON.parse(value);
        return  val ? val.value : '';
    }
}
